export enum AccessibilitaDisabiliEnum {
    'Deambulanti con difficoltà' = 1,
    'Sedia a ruote',
    'Sedia a ruote con accompagnatore',
    'Ipovedenti',
    'Ipovedenti con accompagnatore',
    'Disabilità motoria',
    'Nessuna'
}